// #@flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import DisplayImage from "./image.png";

const description =
  "An interactive that provides a profile story that can be expanded and collapsed.";

const CONFIG: InteractivesMenuItemConfig = {
  name: "Collapsible profile",
  id: "collapsible-profile",
  linkPrefix: "/interactives",
  tags: ["Profile", "Configurable"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/collapsible-profile/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import("app/components/tools/CollapsibleProfileConfigTool/CollapsibleProfileConfigTool"),
    loading: DynamicImportLoader,
    modules: ["CollapsibleProfileConfigTool"]
  })
};

export default CONFIG;
